export const TIME_COLUMN_WIDTH = 100;
export const STUDIO_COL_WIDTH = 150;
export const MONTAGE_GAP = 30;
/** 1030 контент + 5px border-right + 5px border-left (первая ячейка) */
export const DAY_CELL_WIDTH = TIME_COLUMN_WIDTH + 6 * STUDIO_COL_WIDTH + MONTAGE_GAP + 10;
export const DAY_HEIGHT = 865;
export const DAY_CELL_HEIGHT = 878; /* DAY_HEIGHT + 5px border + 8px нижний отступ */
export const SCHEDULE_DAY_GAP = 10; /* отступ между карточками дней */
export const CONTENT_HEIGHT = DAY_HEIGHT - 70;
export const HEADER_HEIGHT = 35;
export const STUDIO_HEADER_HEIGHT = 35;

export const STUDIOS = [
  '1 СТУДИЯ',
  '2 СТУДИЯ',
  '3 СТУДИЯ',
  '4 СТУДИЯ',
  '1 МОНТАЖНАЯ',
  '2 МОНТАЖНАЯ',
];

export const MONTH_NAMES = [
  'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
];

export const DAY_NAMES = [
  'ВОСКРЕСЕНЬЕ', 'ПОНЕДЕЛЬНИК', 'ВТОРНИК', 'СРЕДА',
  'ЧЕТВЕРГ', 'ПЯТНИЦА', 'СУББОТА',
];

export const TOTAL_MINUTES = 12 * 60; // 09:00..21:00

export const TIME_SLOTS = [
  '09:00 - 09:30', '09:30 - 10:00', '10:00 - 10:30', '10:30 - 11:00',
  '11:00 - 11:30', '11:30 - 12:00', '12:00 - 12:30', '12:30 - 13:00',
  '13:00 - 13:30', '13:30 - 14:00', '14:00 - 14:30', '14:30 - 15:00',
  '15:00 - 15:30', '15:30 - 16:00', '16:00 - 16:30', '16:30 - 17:00',
  '17:00 - 17:30', '17:30 - 18:00', '18:00 - 18:30', '18:30 - 19:00',
  '19:00 - 19:30', '19:30 - 20:00', '20:00 - 20:30', '20:30 - 21:00',
];
